const SessionTwoFacultyList = [
    {
      image: "/jitish-bio-scaled.jpg",
      title: "Jitish Kallat",
      description: "Leading Contemporary Artist and Curator",
      link: "/teams/jitish-kallat",
    },
    {
        image: "/Kamayani-Sharma-bio.jpg",
        title: "Kamayani Sharma",
        description: "Independent Writer, Researcher, Translator and Podcaster",
        link: "/teams/kamayani-sharma"
      },
    {
      image: "/Meera-M_-photo-copyright-Parthiv-Shah-1.jpg",
      title: "Meera Menezes",
      description: "Art Critic & Independent Curator",
      link: "/teams/meera-menezes",
    },
      {
        image: "/Sandhya-Bordewekar-bio-scaled.jpg",
        title: "Sandhya Bordewekar",
        description: "Art Educator, Writer and Curator",
        link: "/teams/sandhya-bordewekar"
      },
      {
        image: "/Tasneem-Zakaria-Mehta-2.jpg",
        title: "Tasneem Zakaria Mehta",
        description: "Managing Trustee and Honorary Director, Dr. Bhau Daji Lad Museum, Mumbai",
        link: "/teams/tasneem-zakaria-mehta"
      },
  ];

  export default SessionTwoFacultyList;